import { Record as record } from 'immutable';

import trainTime from '../lib/TrainTime';
import { construct, fields, resolve } from '../helpers/LinkMapper';
import { getDefaults, getResolvers } from '../helpers/Records';
import { serialize, serializers } from '../helpers/SearchUrls';


const fieldSchema = {
    trainUid: [fields.number],
    origin: [fields.string],
    originStationDetail: null,
    destination: [fields.string],
    destinationStationDetail: null,
    departureDate: [resolve.with(date => trainTime(date, 'YYYY-MM-DD'))],
    departureTime: [resolve.with(time => trainTime(time, 'HH:mm:ss'))],
    arrivalTime: [resolve.with(date => trainTime(date, 'YYYY-MM-DD'))],
    legOrder: [fields.number],
    groupId: [fields.string, null],
};

class CustomerServiceChangeLeg extends record(
    getDefaults(fieldSchema)
) {
    static fromJSON (json = {}) {
        return construct(CustomerServiceChangeLeg, json, getResolvers(fieldSchema));
    }

    toJSON () {
        return serialize({
            trainUid: serializers.identity,
            origin: serializers.identity,
            originStationDetail: serializers.identity,
            destination: serializers.identity,
            destinationStationDetail: serializers.identity,
            departureDate: departureDate => departureDate ? serializers.date(departureDate) : null,
            departureTime: departureTime => departureTime ? serializers.time(departureTime) : null,
            arrivalTime: departureTime => departureTime ? serializers.time(departureTime) : null,
            legOrder: serializers.identity,
            groupId: serializers.identity,
        }, this);
    }
}

export default CustomerServiceChangeLeg;
